export const isIri = (potentialIri: string | undefined | null): boolean =>
  !!potentialIri?.includes('/api/')
